// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
     * A PEN BY Fazlul karim. MIT license.
     */
.breadcrumb[data-v-ba353cd2] {
  display: inline-block;
  border-radius: 5px;
  transform: scale(0.7);
}
.breadcrumb a[data-v-ba353cd2] {
  font-family: 'Roboto', sans-serif;
  text-decoration: none;
  outline: none;
  display: block;
  float: left;
  color: white;
  font-size: 14px;
  line-height: 60px;
  width: auto;
  position: relative;
  background: grey;
  padding-left: 50px;
  padding-right: 20px;
}
.breadcrumb a.done[data-v-ba353cd2] {
  background: #002f87;
  transition: all 0.5s;
}
.breadcrumb a.done[data-v-ba353cd2]:after {
  background: #002f87;
  transition: all 0.5s;
}
.breadcrumb a.active[data-v-ba353cd2] {
  background: #ff4539;
  transition: all 0.5s;
}
.breadcrumb a[data-v-ba353cd2]:hover {
  background: #ffd100;
  transition: all 0.5s;
}
.breadcrumb a.active[data-v-ba353cd2]:after {
  background: #ff4539;
  transition: all 0.5s;
}
.breadcrumb a[data-v-ba353cd2]:hover:after {
  background: #ffd100;
  transition: all 0.5s;
}
.breadcrumb a[data-v-ba353cd2]:after {
  content: "";
  position: absolute;
  top: 0;
  right: -30px;
  width: 60px;
  height: 60px;
  transform: scale(0.707) rotate(45deg);
  z-index: 1;
  background: grey;
  box-shadow: 3px -3px 0 2px rgba(255, 255, 255, 0.8);
  border-radius: 0 5px 0 50px;
}
/**
    .breadcrumb a:last-child:after {
        content: none;
    }

    .breadcrumb a:last-child {
        width: 342px;
    }
    */
`, "",{"version":3,"sources":["webpack://./np-breadcrumb.vue","webpack://./src/js/netpify/components/np-breadcrumb.vue"],"names":[],"mappings":"AAAA;;MAEM;ACWF;EACI,qBAAA;EACA,kBAAA;EACA,qBAAA;ADTR;ACYI;EACI,iCAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ADVR;ACaI;EACI,mBAAA;EACA,oBAAA;ADXR;ACaI;EACI,mBAAA;EACA,oBAAA;ADXR;ACcI;EACI,mBAAA;EACA,oBAAA;ADZR;ACeI;EACI,mBAAA;EACA,oBAAA;ADbR;ACgBI;EACI,mBAAA;EACA,oBAAA;ADdR;ACiBI;EACI,mBAAA;EACA,oBAAA;ADfR;ACkBI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,UAAA;EACA,gBAAA;EACA,mDAAA;EACA,2BAAA;ADhBR;AACA;;;;;;;;KAQK","sourcesContent":["/**\n     * A PEN BY Fazlul karim. MIT license.\n     */\n.breadcrumb {\n  display: inline-block;\n  border-radius: 5px;\n  transform: scale(0.7);\n}\n.breadcrumb a {\n  font-family: 'Roboto', sans-serif;\n  text-decoration: none;\n  outline: none;\n  display: block;\n  float: left;\n  color: white;\n  font-size: 14px;\n  line-height: 60px;\n  width: auto;\n  position: relative;\n  background: grey;\n  padding-left: 50px;\n  padding-right: 20px;\n}\n.breadcrumb a.done {\n  background: #002f87;\n  transition: all 0.5s;\n}\n.breadcrumb a.done:after {\n  background: #002f87;\n  transition: all 0.5s;\n}\n.breadcrumb a.active {\n  background: #ff4539;\n  transition: all 0.5s;\n}\n.breadcrumb a:hover {\n  background: #ffd100;\n  transition: all 0.5s;\n}\n.breadcrumb a.active:after {\n  background: #ff4539;\n  transition: all 0.5s;\n}\n.breadcrumb a:hover:after {\n  background: #ffd100;\n  transition: all 0.5s;\n}\n.breadcrumb a:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: -30px;\n  width: 60px;\n  height: 60px;\n  transform: scale(0.707) rotate(45deg);\n  z-index: 1;\n  background: grey;\n  box-shadow: 3px -3px 0 2px rgba(255, 255, 255, 0.8);\n  border-radius: 0 5px 0 50px;\n}\n/**\n    .breadcrumb a:last-child:after {\n        content: none;\n    }\n\n    .breadcrumb a:last-child {\n        width: 342px;\n    }\n    */\n","\n    /**\n     * A PEN BY Fazlul karim. MIT license.\n     */\n    @crane-blue: rgb(0 ,47, 135);\n    @crane-yellow: rgb(255, 209, 0);\n    @crane-red: rgb(255, 69, 57);\n    @crane-black: rgb(45,42,38);\n\n    @background: grey;\n    @background-done: @crane-blue;\n    @background-active: @crane-red;\n    @background-hover: @crane-yellow;\n    .breadcrumb {\n        display: inline-block;\n        border-radius: 5px;\n        transform: scale(0.7);\n    }\n\n    .breadcrumb a {\n        font-family: 'Roboto', sans-serif;\n        text-decoration: none;\n        outline: none;\n        display: block;\n        float: left;\n        color: white;\n        font-size: 14px;\n        line-height: 60px;\n        width: auto;\n        position: relative;\n        background: @background;\n        padding-left: 50px;\n        padding-right: 20px;\n    }\n\n    .breadcrumb a.done {\n        background: @background-done;\n        transition: all 0.5s;\n    }\n    .breadcrumb a.done:after {\n        background: @background-done;\n        transition: all 0.5s;\n    }\n\n    .breadcrumb a.active {\n        background: @background-active;\n        transition: all 0.5s;\n    }\n\n    .breadcrumb a:hover {\n        background: @background-hover;\n        transition: all 0.5s;\n    }\n\n    .breadcrumb a.active:after {\n        background: @background-active;\n        transition: all 0.5s;\n    }\n\n    .breadcrumb a:hover:after {\n        background: @background-hover;\n        transition: all 0.5s;\n    }\n\n    .breadcrumb a:after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: -30px;\n        width: 60px;\n        height: 60px;\n        transform: scale(0.707) rotate(45deg);\n        z-index: 1;\n        background: @background;\n        box-shadow: 3px -3px 0 2px rgba(255, 255, 255, 0.8);\n        border-radius: 0 5px 0 50px;\n    }\n\n    /**\n    .breadcrumb a:last-child:after {\n        content: none;\n    }\n\n    .breadcrumb a:last-child {\n        width: 342px;\n    }\n    */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
